import { render, staticRenderFns } from "./WarBoard.vue?vue&type=template&id=3b131b22&scoped=true&"
import script from "./WarBoard.vue?vue&type=script&lang=js&"
export * from "./WarBoard.vue?vue&type=script&lang=js&"
import style0 from "./WarBoard.vue?vue&type=style&index=0&id=3b131b22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b131b22",
  null
  
)

export default component.exports